function getPipeTitle({ keyword, suburb }) {
  const pipeTitles = {
    Plumbers: `| ${suburb} Plumber `,
    Awnings: '| External & Retractable ',
    Windows: '| Installations ',
    'Aluminium Windows': '| Installations ',
    'Towing Services': '| Tow Trucks ',
    'Caravans Sales & Parts': '| New & Used ',
    'Deck Builders': '| Timber Decking ',
    Landscapers: '| Landscape Design ',
    'Windscreen Repairs': '| Chip Repair ',
    Restaurants: `| ${suburb} Restaurants `,
    Tyres: `| Tyre Shops Near Me `,
    Florists: `| ${suburb} Flower Delivery `,
    Electricians: `| Electrical ${suburb} `,
    Mechanics: `| Car Service Near Me `,
    'Air Conditioning': `| Aircon ${suburb} `,
    Builders: `| ${suburb} Builders `,
    'Pest Control': `| ${suburb} Pest Control `,
    Locksmiths: `| ${suburb} Locksmith `,
    'Garage Doors': `| Garage Door Repairs `,
    'Kitchen Renovations & Designers': `| ${suburb} Kitchen Renovations & Design `,
    'Excavator & Earthmoving Hire': `| ${suburb} Excavators `,
    'Building & Pest Inspections': `| ${suburb} Building Inspections `,
    Vets: `| ${suburb} Veterinarians `,
  };

  if (pipeTitles[keyword]) {
    return pipeTitles[keyword];
  }

  return '';
}

function bestTitle() {
  const title = '10 BEST';
  return title;
}

function categoryTitle({ keyword }) {
  const categoryTitles = {
    Electricians: `⚡️ ${keyword}`,
    Plumbers: `🚰 ${keyword}`,
    'Hot Water Systems': `🚿 ${keyword}`,
    Builders: `🔨 ${keyword}`,
    'Pubs & Taverns': `🍻 ${keyword}`,
    Pizza: `🍕 ${keyword}`,
    'Solar Power Systems': `☀️ ${keyword}`,
    'Tree & Stump Removal': `🌲 ${keyword}`,
    Florists: `🌷 ${keyword}`,
    'Air Conditioning': `❄️ ${keyword}`,
    'Adult Entertainment & Escorts': `🍆💦 ${keyword}`,
    Mechanics: `🔧 ${keyword}`,
    Barbers: `💈 ${keyword}`,
    'Roofing Contractors': `🏠 ${keyword}`,
    Blinds: `🖼 ${keyword}`,
    Lawyers: `⚖️ ${keyword}`,
    Batteries: `🔋 ${keyword}`,
    'Bike Shops': `🚲 ${keyword}`,
    Trophies: `🏆 ${keyword}`,
    'Martial Art Schools & Suppliers': `🥋 ${keyword}`,
    'Funeral Directors': `🕊 ${keyword}`,
    'Banks & Building Societies': `🏦 ${keyword}`,
    'Fitness Centres & Gyms': `🏋 ${keyword}`,
    Butchers: `🍖 ${keyword}`,
    Jewellers: `💍 ${keyword}`,
    'Honey Wholesalers': `🍯 ${keyword}`,
    'Security Screens': 'Security Doors & Screens',
    'Glass & Glaziers - Repairs & Replacements': 'Glass Repairs & Replacements',
    Pawnbrokers: `Pawnbrokers & Pawn Shops`,
    'Roadworthy & Safety Certificates': `${keyword} & Blue Slips`,
    'Vehicle Inspections': `${keyword} & Pink Slips`,
  };

  if (categoryTitles[keyword]) {
    return categoryTitles[keyword];
  }

  return keyword;
}

const getYear = () => {
  const month = new Date().getMonth();
  const year = new Date().getFullYear();
  const displayYear = year;
  if (month > 10) {
    return ` [${displayYear + 1}] `;
  }
  return ` [${displayYear}] `;
};

const LISTVIEW_TITLE_TAGS = ({ keyword, suburb, state, postcode }) => {
  const pipeTitle = getPipeTitle({ keyword, suburb, state });
  const titleTag = `${`${bestTitle()} ${categoryTitle({
    keyword,
  })}`} in ${suburb} ${state}${
    postcode ? ` ${postcode}` : ''
  }${getYear()} ${pipeTitle}| Localsearch`;
  return titleTag.trim();
};

export default LISTVIEW_TITLE_TAGS;
